import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export type ColorSchema =
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';

declare module '@mui/material/styles/createPalette' {
    interface TypeBackground {
        neutral: string;
        mainBackground: string;
    }
    // interface SimplePaletteColorOptions {
    //     lighter: string;
    //     darker: string;
    // }
    // interface PaletteColor {
    //     lighter: string;
    //     darker: string;
    // }
}

// SETUP COLORS

const GREY = {
    0: '#FFFFFF',
    100: '#F9FAFB',
    200: '#ECECEC', // Grey4
    300: '#D8D8D8', // Grey3
    400: '#B5B5B5', // Grey2
    500: '#919EAB',
    600: '#727272', // Grey
    700: '#454F5B',
    800: '#212B36',
    900: '#161C24',
};

const PRIMARY = {
    light: '#F3E7FF',
    main: '#7E00FF',
    dark: '#A750FF',
};

const SECONDARY = {
    light: '#FFE4C9',
    main: '#FF7F00',
    dark: '#FF7F00',
};

const INFO = {
    light: '#E2F2FF',
    main: '#0080FF',
    dark: '#0080FF',
};

const SUCCESS = {
    light: '#CDF0D1',
    main: '#06B217',
    dark: '#1B806A',
};

const WARNING = {
    light: '#FFE4C9',
    main: '#FF7F00',
    dark: '#FF7F00',
};

const ERROR = {
    light: '#FFD7CC',
    main: '#BF2700',
    dark: '#BF2700',
};

const COMMON = {
    common: { black: '#000000', white: '#FFFFFF' },
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    divider: alpha(GREY[500], 0.24),
    action: {
        hover: alpha(GREY[500], 0.08),
        selected: alpha(GREY[500], 0.16),
        disabled: alpha(GREY[500], 0.8),
        disabledBackground: alpha(GREY[500], 0.24),
        focus: alpha(GREY[500], 0.24),
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};

export default function palette(themeMode: 'light' | 'dark') {
    const light = {
        ...COMMON,
        mode: 'light',
        text: {
            primary: GREY[800],
            secondary: GREY[600],
            disabled: GREY[500],
        },
        background: {
            paper: '#FFFFFF',
            default: '#FFFFFF',
            neutral: GREY[200],
            mainBackground: '#F2F2F2',
        },
        action: {
            ...COMMON.action,
            active: GREY[600],
        },
    } as const;

    const dark = {
        ...COMMON,
        mode: 'dark',
        text: {
            primary: '#FFFFFF',
            secondary: GREY[500],
            disabled: GREY[600],
        },
        background: {
            paper: GREY[800],
            default: GREY[900],
            neutral: alpha(GREY[500], 0.16),
        },
        action: {
            ...COMMON.action,
            active: GREY[500],
        },
    } as const;

    return themeMode === 'light' ? light : dark;
}
